import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ActionCard from './action-card'
import {
  StyledCardName,
  StyledCardLabel,
  StyledCardNumber,
  StyledCardDetails,
  StyledCardHolderName,
  StyledExpiredDate,
  StyledPadCardFooter,
  StyledPadCardDeailsDiv,
  StyledRoutingNumber,
  StyledMandateButton,
  StyledSepaCardNumber,
} from './atoms'
import { StyledDefaultTag } from 'portal-modules/common/components/atoms'
import displayMaskedNumber from 'portal-modules/common/utils/display-masked-number'
import styled from '@emotion/styled'
import {
  PLAID_ERROR_CODES,
  PLAID_ITEM_FATAL_ERROR_TYPES,
  PLAID_ITEM_FATAL_ERROR_CODES,
} from 'portal-modules/common/constants/plaid'
import cardIcons from 'portal-modules/payments/constants/card-icons'
import { StyledReason } from 'portal-modules/common/components/atoms'
import isPast from 'date-fns/isPast'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
import { PAYMENT_TYPES, GATEWAY_TYPES } from 'portal-modules/payments/constants'
import PendingAutomaticAuthorization from 'portal-modules/common/components/PendingAutomaticAuthorization'
import SepaMandateModal from 'portal-modules/payments/components/modals/SepaMandateModal'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import { PLAID_RELINK_BANNER_DAYS } from 'portal-modules/common/constants/plaid'
import { FlexIcon } from 'portal-modules/common/svgs/FlexIcon'
import { BacsCard } from './BacsCard'

const StyledActionCard = styled(ActionCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  background: ${({ disabled, theme, disableFlexPaymentAccount }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : disabled
      ? theme.mode.card_disabled_background
      : theme.mode.card_background_color};
`

const TweakedCardNumber = styled(StyledCardNumber)`
  font-size: 12px;
`

const CCCard = ({
  nickname,
  card_info: { name_on_card, masked_card_number, exp_month, exp_year, is_international, card_type_id = PAYMENT_TYPES.CARD.value},
  Icon,
  onDelete,
  onEdit,
  paymentTypeId,
  isFromWallet,
  isAddAutoPaymentAllowed,
  isDeleteAutoPaymentAllowed,
  isEditAutoPaymentAllowed,
  deletePaymentMethodAccess,
  addPaymentMethodAccess,
  editPaymentMethodAccess,
  disableFlexPaymentAccount,
  gatewayProvider,
  isScreeningEnabled,
  isScreeningValidationEnabled,
  is_default_account,
  ...rest
}) => {
  let isEnableEdit = true
  let isDisabledDelete = false
  let isDisable = false
  let strDisableMessage = null 
  let warningMessage

  // Check payment method screening is empty or not
  const isPaymentMethodScreeningEmpty = !rest.payment_method_screening || rest.payment_method_screening.length === 0;

  if (
    isScreeningEnabled &&
    strDisableMessage == null &&
    is_international &&
    (isPaymentMethodScreeningEmpty ||
      (rest.payment_method_screening.hasOwnProperty('is_self_verified') &&
        !rest.payment_method_screening.is_self_verified))
  ) {
    strDisableMessage = __('Pending Info Verification')
    warningMessage = 'pending_screening_info_verification'
  }

  if( disableFlexPaymentAccount ) {
    isEnableEdit = false
    isDisabledDelete = isDisable = true
    strDisableMessage = __('Enrolled ')
    warningMessage = 'disable_flex_payment_account'
  }
  // We are setting the icon for the stripe card based on the card_type_id
  const StripeCardIcon = cardIcons[card_type_id]

  return (
    <StyledActionCard
      {...rest}
      isFromWallet={isFromWallet}
      onDelete={isDisabledDelete ? null : onDelete}
      onEdit={onEdit}
      disabled={isDisable}
      allowedEdit={isEnableEdit}
      disableFlexPaymentAccount={disableFlexPaymentAccount}
      title={
        paymentTypeId === PAYMENT_TYPES?.AMEX.value ? (
          <Icon height={'48px'} width={'50px'} style={{ marginRight: 'auto', marginTop: '-14px', marginLeft: '-12px' }} />
        ) : paymentTypeId === PAYMENT_TYPES?.CARD.value ? (
          //We are setting height, width and other style based on card type
          <StripeCardIcon 
            height={
              card_type_id === PAYMENT_TYPES?.AMEX.value 
              ? '48px'
              : card_type_id === PAYMENT_TYPES?.CARD.value
              ? '30px'
              : '40px'} 
            width={
              card_type_id === PAYMENT_TYPES?.AMEX.value
              ? '50px'
              : card_type_id === PAYMENT_TYPES?.CARD.value 
              ? '40px'
              : '90px'} 
            style={{
              marginRight: 'auto',
              marginTop:
              card_type_id === PAYMENT_TYPES?.VISA.value ? '-14px' : '-8px',
              marginLeft:
              card_type_id === PAYMENT_TYPES?.MASTERCARD.value
                  ? '-24px'
                  : card_type_id === PAYMENT_TYPES?.VISA.value
                  ? '-20px'
                  : card_type_id === PAYMENT_TYPES?.CARD.value
                  ? '-8px'
                  : '',
            }} />
        )
        : (
          <Icon
            height={'40px'}
            width={
              card_type_id === PAYMENT_TYPES?.DISCOVER.value
                ? '60px'
                : '90px'
            }
            style={{
              marginRight: 'auto',
              marginTop:
                paymentTypeId === PAYMENT_TYPES?.VISA.value ? '-14px' : '-8px',
              marginLeft:
                paymentTypeId === PAYMENT_TYPES?.MASTERCARD.value
                  ? '-24px'
                  : paymentTypeId === PAYMENT_TYPES?.VISA.value
                  ? '-20px'
                  : '',
            }}
          />
        )
      }
      isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
      isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
      isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
      deletePaymentMethodAccess={deletePaymentMethodAccess}
      editPaymentMethodAccess={editPaymentMethodAccess}
      addPaymentMethodAccess={addPaymentMethodAccess}
    >
      <StyledCardName>{nickname}</StyledCardName>
      <TweakedCardNumber>
        {displayMaskedNumber(paymentTypeId)(masked_card_number)}
      </TweakedCardNumber>
      <StyledCardDetails>
        <StyledCardHolderName>{name_on_card}</StyledCardHolderName>
        <StyledExpiredDate>
          {__('Exp: {%s, 0}/{%d, 1}', [
            +exp_month < 10 ? '0' + exp_month : exp_month,
            exp_year ? exp_year.toString().slice(-2) : '',
          ])}
        </StyledExpiredDate>
      </StyledCardDetails>
      {strDisableMessage ? (
        <StyledReason disableFlexPaymentAccount={disableFlexPaymentAccount}>
          {strDisableMessage}
          {warningMessage &&
          <PendingAutomaticAuthorization
              plaidStatusPendingOrFailed={warningMessage}
            />
          }
        </StyledReason>
        ) : (
          is_default_account && <StyledDefaultTag>{__('Default')}</StyledDefaultTag>
        )
      }
      
    </StyledActionCard>
  )
}

CCCard.propTypes = {
  alt: PropTypes.string,
  card_info: PropTypes.any.isRequired,
  Icon: PropTypes.func.isRequired,
  nickname: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  paymentTypeId: PropTypes.number,
  src: PropTypes.string,
  isFromWallet: PropTypes.bool,
  isAddAutoPaymentAllowed: PropTypes.bool,
  isDeleteAutoPaymentAllowed: PropTypes.bool,
  isEditAutoPaymentAllowed: PropTypes.bool,
  deletePaymentMethodAccess: PropTypes.bool,
  addPaymentMethodAccess: PropTypes.bool,
  editPaymentMethodAccess: PropTypes.bool,
}

CCCard.defaultProps = {
  isFromWallet: true,
}

const MoneyGramCard = ({
  customer_first_name,
  moneygram_account_number,
  Icon,
  onEdit,
  onDelete,
  ...rest
}) => (
  <StyledActionCard
    title={<Icon.icon size={'32px'} style={{ marginRight: 'auto' }} />}
    {...rest}
  >
    <StyledCardName>MoneyGram</StyledCardName>
    <StyledCardNumber>{moneygram_account_number}</StyledCardNumber>
    <StyledCardDetails>
      <StyledCardHolderName>{customer_first_name}</StyledCardHolderName>
    </StyledCardDetails>
  </StyledActionCard>
)

MoneyGramCard.propTypes = {
  customer_first_name: PropTypes.string.isRequired,
  moneygram_account_number: PropTypes.string.isRequired,
  Icon: PropTypes.object,
}

const PADCard = ({
  nickname,
  cardLabel,
  bank_info: {
    bank_name = '',
    routing_number = '',
    account_number = '',
    account_number_masked = '',
    plaid_item_error,
    plaid_verification_status,
    plaid_consent_expiration_time,
    account_type_id,
  } = {}, // Default to empty object if bank_info is undefined
  Icon,
  onDelete,
  onEdit,
  paymentTypeId,
  isFromWallet,
  relinkAccountId,
  refundPlaidItemError,
  refund_plaid_verification_status,
  isAddAutoPaymentAllowed,
  isDeleteAutoPaymentAllowed,
  isEditAutoPaymentAllowed,
  deletePaymentMethodAccess,
  addPaymentMethodAccess,
  editPaymentMethodAccess,
  isScreeningEnabled,
  isScreeningValidationEnabled,
  disableFlexPaymentAccount,
  is_default_account = false,
  ...rest
}) => {
  let strPlaidReasonTxt = null
  let isDisableEdit = false
  let isDisableDelete = false
  var date = new Date()
  date.setDate(date.getDate() + PLAID_RELINK_BANNER_DAYS)
  let isDisabled = false
  let plaidStatusPendingOrFailed

  if (
    relinkAccountId ||
    (bank_name && bank_name !== 'TD Bank' &&
      plaid_consent_expiration_time &&
      (isPast(plaid_consent_expiration_time) ||
        i18nUtils.datetime(plaid_consent_expiration_time, 'DATETIME_ISO') <
          i18nUtils.datetime(date.toISOString(), 'DATETIME_ISO') ||
        plaid_item_error?.error_code == 'ITEM_LOGIN_REQUIRED'))
  ) {
    if (plaid_verification_status == 'verification_expired') {
      isDisabled = true
      isDisableEdit = true
      strPlaidReasonTxt = __('This account cannot be verified')
      plaidStatusPendingOrFailed = 'verification_expired'
    } else {
      strPlaidReasonTxt = __('Account needs to be relinked')
    }
  } else if (
    plaid_item_error &&
    plaid_item_error.error_type &&
    plaid_item_error.error_code
  ) {
    if (
      PLAID_ITEM_FATAL_ERROR_TYPES.includes(plaid_item_error.error_type) &&
      PLAID_ITEM_FATAL_ERROR_CODES.includes(plaid_item_error.error_code)
    ) {
      if (
        PLAID_ERROR_CODES.ITEM_ERROR.USER_PERMISSION_REVOKED ==
        plaid_item_error?.error_code
      ) {
        strPlaidReasonTxt = __('Access Revoked')
        plaidStatusPendingOrFailed = 'user_permission_revoked'
      } else {
        strPlaidReasonTxt = __('This account cannot be verified')
        plaidStatusPendingOrFailed = 'failed_automatic_verification'
      }
    }

    isDisableEdit = !!strPlaidReasonTxt
    isDisabled = true
  } else if (refundPlaidItemError?.error_type?.error_code) {
    const { error_type, error_code } = refundPlaidItemError

    if (
      PLAID_ITEM_FATAL_ERROR_TYPES.includes(plaid_item_error.error_type) &&
      PLAID_ITEM_FATAL_ERROR_CODES.includes(plaid_item_error.error_code)
    ) {
      strPlaidReasonTxt = __('This account cannot be verified')
      plaidStatusPendingOrFailed = 'failed_automatic_verification'
    }

    isDisabled = true
  } else if (refund_plaid_verification_status) {
    switch (refund_plaid_verification_status) {
      case 'pending_automatic_verification':
        isDisableEdit = true
        strPlaidReasonTxt = __('Pending Automatic Authorization')
        plaidStatusPendingOrFailed = 'pending_automatic_verification'
        break

      case 'pending_manual_verification':
        strPlaidReasonTxt = __('Pending Micro-deposit Confirmation')
        plaidStatusPendingOrFailed = 'pending_manual_verification'
        break
      default:
        strPlaidReasonTxt = null
    }
  } else if (plaid_verification_status) {
    switch (plaid_verification_status) {
      case 'pending_automatic_verification':
        isDisableEdit = true
        strPlaidReasonTxt = __('Pending Automatic Authorization')
        plaidStatusPendingOrFailed = 'pending_automatic_verification'
        break

      case 'account_deleted_or_obsolete':
        isDisabled = true
        isDisableEdit = true
        strPlaidReasonTxt = __('Invalid Account Number')
        plaidStatusPendingOrFailed = 'account_deleted_or_obsolete'
        break

      case 'verification_expired':
        isDisabled = true
        isDisableEdit = true
        strPlaidReasonTxt = __('This account cannot be verified')
        plaidStatusPendingOrFailed = 'verification_expired'
        break

      case 'pending_manual_verification':
        strPlaidReasonTxt = __('Pending Micro-deposit Confirmation')
        plaidStatusPendingOrFailed = 'pending_manual_verification'
        break

      case 'manually_verified':
      case true:
        if (routing_number == '-') {
          isDisabled = true
          isDisableEdit = true
          strPlaidReasonTxt = __('This account cannot be verified')
          plaidStatusPendingOrFailed = 'failed_manual_verification'
        }
        break

      default:
        strPlaidReasonTxt = null
    }
  }

  const { isNotRP } = getProjectConditions()

  if (
    isNotRP &&
    PAYMENT_TYPES.ECHECK.value == paymentTypeId &&
    [3, 4].includes(account_type_id)
  ) {
    strPlaidReasonTxt = __('Personal Bank Accounts Not Allowed')
  }

  // Check payment method screening is empty or not
  const isPaymentMethodScreeningEmpty = !rest.payment_method_screening || rest.payment_method_screening.length === 0;

  if (
    isScreeningEnabled &&
    isScreeningValidationEnabled &&
    strPlaidReasonTxt == null &&
    (isPaymentMethodScreeningEmpty ||
      (rest.payment_method_screening.hasOwnProperty('is_self_verified') &&
        !rest.payment_method_screening.is_self_verified))
  ) {
    //Here we are using existing variables but this functionality is not related to plaid
    strPlaidReasonTxt = __('Pending Info Verification')
    plaidStatusPendingOrFailed = 'pending_screening_info_verification'
  }

  if (disableFlexPaymentAccount) {
    isDisableEdit = isDisabled = isDisableDelete = true
    strPlaidReasonTxt = __('Enrolled')
    plaidStatusPendingOrFailed = 'disable_flex_payment_account'
  }

  const getName = () => {
    // Make sure we have valid strings for nickname and bank_name
    const validNickname = nickname || '';
    const validBankName = bank_name || '';
    
    // Only add bank name if it exists
    let completeName = validNickname;
    if (validBankName) {
      completeName = validNickname ? `${validNickname} - ${validBankName}` : validBankName;
    }
    
    return completeName.length > 18
      ? completeName.slice(0, 18) + '...'
      : completeName
  }

  return (
    <StyledActionCard
      {...rest}
      isFromWallet={isFromWallet}
      onDelete={isDisableDelete ? null : onDelete}
      onEdit={isDisableEdit ? null : onEdit}
      disabled={isDisabled}
      disableFlexPaymentAccount={disableFlexPaymentAccount}
      title={
        <Fragment>
          {disableFlexPaymentAccount ? (
            <FlexIcon
              height={'26px'}
              width={'45px'}
              style={{ marginRight: 'auto' }}
            />
          ) : (
            <Icon size={'40px'} style={{ marginRight: 'auto', marginTop: '-12px' }} />
          )}
          <StyledCardLabel>{cardLabel}</StyledCardLabel>
        </Fragment>
      }
      isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
      isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
      isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
      deletePaymentMethodAccess={deletePaymentMethodAccess}
      editPaymentMethodAccess={editPaymentMethodAccess}
      addPaymentMethodAccess={addPaymentMethodAccess}
    >
      <StyledCardName>{getName()}</StyledCardName>
      <StyledPadCardFooter>
        <StyledPadCardDeailsDiv>
          <span>{__('Account Number')}</span>
          <StyledRoutingNumber>
            {account_number_masked
              ? displayMaskedNumber(paymentTypeId)(account_number_masked)
              : account_number}
          </StyledRoutingNumber>
        </StyledPadCardDeailsDiv>
        <StyledPadCardDeailsDiv>
          <span>{__('Routing Number')}</span>
          <StyledRoutingNumber>{routing_number}</StyledRoutingNumber>
        </StyledPadCardDeailsDiv>
      </StyledPadCardFooter>
      {strPlaidReasonTxt && (
        <StyledReason disableFlexPaymentAccount={disableFlexPaymentAccount}>
          {strPlaidReasonTxt}{' '}
          {plaidStatusPendingOrFailed && (
            <PendingAutomaticAuthorization
              plaidStatusPendingOrFailed={plaidStatusPendingOrFailed}
              onDelete={onDelete}
            />
          )}
        </StyledReason>
      )}
      {
        is_default_account && 
        <StyledDefaultTag>{__('Default')}</StyledDefaultTag>
      }
    </StyledActionCard>
  )
}

PADCard.propTypes = {
  alt: PropTypes.string,
  bank_info: PropTypes.any.isRequired,
  cardLabel: PropTypes.string,
  Icon: PropTypes.func.isRequired,
  img: PropTypes.string,
  nickname: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  paymentTypeId: PropTypes.number,
  src: PropTypes.string,
  isFromWallet: PropTypes.bool,
  relinkAccountId: PropTypes.number,
  isAddAutoPaymentAllowed: PropTypes.bool,
  isEditAutoPaymentAllowed: PropTypes.bool,
  isDeleteAutoPaymentAllowed: PropTypes.bool,
  deletePaymentMethodAccess: PropTypes.bool,
  addPaymentMethodAccess: PropTypes.bool,
  editPaymentMethodAccess: PropTypes.bool,
}

PADCard.defaultProps = {
  nickname: '',
  isFromWallet: true,
}

const SEPACard = ({
  id,
  nickname,
  cardLabel,
  sepa_info: { iban = '', debtor_name },
  Icon,
  onDelete,
  isAddAutoPaymentAllowed,
  isEditAutoPaymentAllowed,
  isDeleteAutoPaymentAllowed,
  deletePaymentMethodAccess,
  addPaymentMethodAccess,
  editPaymentMethodAccess,
  ...rest
}) => (
  <StyledActionCard
    {...rest}
    isFromWallet={true}
    onDelete={onDelete}
    isSepa={true}
    title={
      <Fragment>
        <Icon
          size={'48px'}
          style={{ marginRight: 'auto', marginTop: '-14px' }}
        />
        <StyledCardLabel>{cardLabel}</StyledCardLabel>
      </Fragment>
    }
    isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
    isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
    isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
    deletePaymentMethodAccess={deletePaymentMethodAccess}
    editPaymentMethodAccess={editPaymentMethodAccess}
    addPaymentMethodAccess={addPaymentMethodAccess}
  >
    <StyledCardName>{nickname ? nickname : `SEPA Direct Debit`}</StyledCardName>
    <StyledSepaCardNumber>
      <strong>
        {
          // TODO : The star needs to be converted from the BackEnd Only.
          // However, As there are multiple places which are going to affect in backend so we are adding this logic for now.
          displayMaskedNumber(PAYMENT_TYPES.SEPA.value)(
            iban.toString().replaceAll('*', 'X'),
          )
        }
      </strong>
    </StyledSepaCardNumber>
    <StyledCardDetails>
      <StyledCardHolderName>{debtor_name}</StyledCardHolderName>
      <ModalControl>
        {({ onClick, ref, ...props }) => (
          <Fragment>
            <StyledMandateButton onClick={onClick}>
              {__('View Sepa Mandate')}
            </StyledMandateButton>
            <SepaMandateModal selectedId={id} {...props} />
          </Fragment>
        )}
      </ModalControl>
    </StyledCardDetails>
  </StyledActionCard>
)

SEPACard.propTypes = {
  alt: PropTypes.string,
  sepa_info: PropTypes.any.isRequired,
  cardLabel: PropTypes.string,
  Icon: PropTypes.func.isRequired,
  img: PropTypes.string,
  nickname: PropTypes.string,
  onDelete: PropTypes.func,
  paymentTypeId: PropTypes.number,
  src: PropTypes.string,
  isAddAutoPaymentAllowed: PropTypes.bool,
  isEditAutoPaymentAllowed: PropTypes.bool,
  isDeleteAutoPaymentAllowed: PropTypes.bool,
  deletePaymentMethodAccess: PropTypes.bool,
  addPaymentMethodAccess: PropTypes.bool,
  editPaymentMethodAccess: PropTypes.bool,
}

SEPACard.defaultProps = {
  nickname: '',
}

const InstantBankTransferCard = ({ Icon }) => {
  return (
    <StyledActionCard
      title={
        <Icon.icon
          height={'48px'}
          width={'50px'}
          style={{ marginRight: 'auto' }}
        />
      }
    >
      <StyledCardName>{__('Instant Bank Transfer')}</StyledCardName>
    </StyledActionCard>
  )
}

InstantBankTransferCard.propTypes = {
  Icon: PropTypes.object,
}

//Card Component for the Bacs payment method
const BACSPaymentCard = ({
  nickname,
  cardLabel,
  bank_info: {
    routing_number,
    account_number_masked,
    mandate_status
  },
  Icon,
  onDelete,
  onEdit,
  paymentTypeId,
  isFromWallet,
  relinkAccountId,
  refundPlaidItemError,
  refund_plaid_verification_status,
  isAddAutoPaymentAllowed,
  isDeleteAutoPaymentAllowed,
  isEditAutoPaymentAllowed,
  deletePaymentMethodAccess,
  addPaymentMethodAccess,
  editPaymentMethodAccess,
  isScreeningEnabled,
  isScreeningValidationEnabled,
  disableFlexPaymentAccount,
  ...rest
}) => {

  return (
    <BacsCard
      {...rest}
      nickname={nickname}
      cardLabel={cardLabel}
      bank_info={{
        routing_number,
        account_number_masked,
        mandate_status
      }}
      Icon={Icon}
      onDelete={onDelete}
      onEdit={onEdit}
      paymentTypeId={paymentTypeId}
      isFromWallet={isFromWallet}
      relinkAccountId={relinkAccountId}
      refundPlaidItemError={refundPlaidItemError}
      refund_plaid_verification_status={refund_plaid_verification_status}
      isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
      isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
      isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
      deletePaymentMethodAccess={deletePaymentMethodAccess}
      addPaymentMethodAccess={addPaymentMethodAccess}
      editPaymentMethodAccess={editPaymentMethodAccess}
      isScreeningEnabled={isScreeningEnabled}
      isScreeningValidationEnabled={isScreeningValidationEnabled}
      disableFlexPaymentAccount={disableFlexPaymentAccount}
    ></BacsCard>
  )
}

export { CCCard, MoneyGramCard, SEPACard, PADCard, InstantBankTransferCard, BACSPaymentCard }
